<script>
import DocumentDetails from '@/components/document-validation/documentDetails/DocumentDetails.vue'
import DocumentCancellationDialog from '@/components/documents/DocumentCancellationDialog.vue'
import ValidationResult from '@/components/document-validation/validationResult/ValidationResult.vue'
export default {
  components: { ValidationResult, DocumentCancellationDialog, DocumentDetails },
  props: {
    validationResults: { type: Array },
    item: { type: Object },
    order: { type: [Object, Array] }
  },
  data() {
    return {
      selectedDocument: null,
      isDocumentCancellationDialogVisible: false,
      isValidationDialogVisible: false,
      validationItem: null
    }
  },
  methods: {
    onCancelledDocuments(items) {
      this.$emit('cancelled', items)
    },
    openValidationResultDialog(validationItem) {
      this.validationItem = validationItem
      this.isValidationDialogVisible = true
      this.$refs.validationResult.load(this.validationItem)
    },
    closeValidationResultDialog() {
      this.isValidationDialogVisible = false
    },

    documentUpdated(event) {
      if (event.updated) {
        event.document.validationStatus = this.$enums.validationStatus.pending
        this.startPolling()
      }
    },
    isPending() {
      return (
        this.$props.item.validationStatus ===
        this.$enums.validationStatus.pending
      )
    },
    openDocumentCancellationDialog(document) {
      this.selectedDocument = document
      this.isDocumentCancellationDialogVisible = true
    },
    closeDocumentCancellationDialog() {
      this.isDocumentCancellationDialogVisible = false
    },
    restartPolling(items) {
      this.$emit('restartPolling', items)
    }
  }
}
</script>
<template>
  <div>
    <DocumentCancellationDialog
      :selected-documents="selectedDocument"
      :is-visible="isDocumentCancellationDialogVisible"
      @cancelled="onCancelledDocuments"
      @close="closeDocumentCancellationDialog"
    />
    <ValidationResult
      ref="validationResult"
      :header="$t('component.documents.documentsTableActions.preview.header')"
      :is-opened="isValidationDialogVisible"
      :close-dialog="closeValidationResultDialog"
      :order="validationItem"
      @updated="documentUpdated">
    </ValidationResult>
    <v-card flat color="transparent">
      <v-card-subtitle name="table-action-container" class="pl-0 pr-0">
        <v-menu bottom left class="secondary--text">
          <template #activator="{ on }">
            <v-btn
              name="actions"
              depressed
              tile
              small
              color="primary"
              width="35"
              min-width="0"
              class="ml-2"
              v-on="on" >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              id="table-document-preview"
              name="preview"
              :disabled="isPending(item)"
              @click="openValidationResultDialog(item)" >
              {{ $t('component.documents.documentsTableActions.table.action.document.preview') }}
            </v-list-item>
            <v-menu
              ref="detailsMenu"
              :close-on-content-click="false"
              :nudge-width="500"
              :max-width="500"
              offset-x>
              <template #activator="{ on: menu, attrs }">
                <v-tooltip top content-class="dark_tip">
                  <template #activator="{ on: tooltip }">
                    <v-list-item
                      id="table-document-details"
                      name="details"
                      :disabled="isPending(item)"
                      v-on="{ ...menu, ...attrs, ...tooltip }">
                      {{ $t('component.documents.documentsTableActions.table.action.details') }}
                    </v-list-item>
                  </template>
                  <span>{{ $t('component.documents.documentsTableActions.table.parcelinformation.tooltip') }}</span>
                </v-tooltip>
              </template>
              <DocumentDetails
                :item="item"
                :order="order"
                :can-delete="
                  $documentsService.canDeleteDocuments(validationResults) "
                @itemsDeleted="
                  restartPolling([item])
                  $emit('update:updated', { orderIds: [item.orderId] }) "
                @coverSheetDeleted="
                  restartPolling([item])
                  $emit('update:updated', { orderIds: [item.orderId] }) "
                @close="$refs.detailsMenu.save()"/>
            </v-menu>
            <v-list-item
              v-if="$documentsService.canCancelDocuments(item, order)"
              id="table-document-cancellation"
              color="error"
              name="cancel"
              :disabled="isPending(item)"
              @click="openDocumentCancellationDialog(item)" >
              {{ $t('component.documents.documentsTableActions.table.action.cancel') }}
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-subtitle>
    </v-card>
    <v-progress-linear
      v-if="isPending(item)"
      indeterminate
      rounded
      height="3"
      color="orange" >
    </v-progress-linear>
  </div>
</template>
